import React from 'react';
import { observer } from 'mobx-react';
import Chat from './chat/Chat';
import Loader from 'react-simple-loading';

import withUserAndRootStoreContext from '../HOC/withUserAndRootStoreContext';

@withUserAndRootStoreContext
@observer
class PrivateChat extends React.Component {
  render () {
    const {
      rootStore: { privateMessagingStore: { globalPresenceSession: { session } } }
    } = this.props;
    return session ? (
      <Chat />
    ) : (
      <div style={{ padding: '20px 0' }}>
        <Loader color={'#AC020A'} />
      </div>
    );
  }
}

export default PrivateChat;